const types = {
	new_offer: 'new_offer',
	offer_stop: 'offer_stop',
	offer_change: 'offer_change',
	geo_added: 'geo_added',
	geo_removed: 'geo_removed',
	new_landing: 'new_landing',
	custom: 'custom',
	promo: 'promo'
};

const locale = {
	ru: {
		new_offer: 'новые офферы',
		offer_stop: 'приостановка офферов',
		offer_change: 'изменение офферов',
		geo_added: 'расширение гео',
		geo_removed: 'остановка гео',
		new_landing: 'новые лендинги',
		custom: 'системные новости',
		promo: 'промо акции'
	},
	en: {
		new_offer: 'new offers',
		offer_stop: 'offer stop',
		offer_change: 'offer change',
		geo_added: 'geo added',
		geo_removed: 'geo removed',
		new_landing: 'new landings',
		custom: 'system news',
		promo: 'promo events'
	},
	uk: {
		new_offer: 'new offers',
		offer_stop: 'offer stop',
		offer_change: 'offer change',
		geo_added: 'geo added',
		geo_removed: 'geo removed',
		new_landing: 'new landings',
		custom: 'system news',
		promo: 'promo events'
	},
	de: {
		new_offer: 'Neue Angebote',
		offer_stop: 'Angebot anhalten',
		offer_change: 'Angebot ändern',
		geo_added: 'GEO hinzugefügt',
		geo_removed: 'GEO entfernt',
		new_landing: 'Neue Landings',
		custom: 'Systemnachrichten',
		promo: 'Promo-Aktionen'
	},
	vi: {
		new_offer: 'új ajánlatok',
		offer_stop: 'ajánlatok leállítása',
		offer_change: 'ajánlatok változtatása',
		geo_added: 'geo bővítése',
		geo_removed: 'geo leállítása',
		new_landing: 'új lendingek',
		custom: 'rendszer újdonságok',
		promo: 'promo akciók'
	},
	th: {
		new_offer: 'ข้อเสนอใหม่',
		offer_stop: 'การระงับฝ่ายต่างๆ',
		offer_change: 'การเปลี่ยนข้อเสนอ',
		geo_added: 'การขยายระบบภูมิสารสนเทศ',
		geo_removed: 'หยุดระบบภูมิสารสนเทศ',
		new_landing: 'ร้านค้าออนไลน์ใหม่',
		custom: 'ข่าสารที่เป็นระบบ',
		promo: 'การส่งเสริมการขาย'
	}
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/news-types.js